import type { ParsedNavigationLink } from '@autobid/strapi-integration/typescript/strapi/Navigation'
import { useStrapiLang } from '@autobid/strapi-integration/composable/useStrapiLang'

export function useFullLink(link: ParsedNavigationLink) {
  const { strapiLang } = useStrapiLang()

  return computed(() => {
    if (link.type === 'EXTERNAL')
      return link.externalPath as string

    if (!link.related)
      return undefined

    const linkData = link.related

    return `/${linkData.locale || strapiLang.value}/${linkData.slug !== '/' ? linkData.slug : ''}`
  })
}
